interface ClosecodeIconProps {
  size?: number | string;
  className?: string;
}

export function ClosecodeIcon({ size = 24, className = "" }: ClosecodeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="dm1_w" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#F97316" />
          <stop offset="50%" stopColor="#EC4899" />
          <stop offset="100%" stopColor="#8B5CF6" />
        </linearGradient>
        <linearGradient id="dm2_w" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#3B82F6" />
          <stop offset="50%" stopColor="#06B6D4" />
          <stop offset="100%" stopColor="#10B981" />
        </linearGradient>
        <linearGradient id="dm3_w" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#EC4899" />
          <stop offset="100%" stopColor="#3B82F6" />
        </linearGradient>
        <linearGradient id="dm4_w" x1="100%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#F97316" />
          <stop offset="100%" stopColor="#06B6D4" />
        </linearGradient>
      </defs>

      <g transform="translate(170, 170)">
        <polygon points="0,-55 55,0 0,55 -55,0" fill="url(#dm1_w)" />
      </g>

      <g transform="translate(342, 170)">
        <polygon points="0,-55 55,0 0,55 -55,0" fill="url(#dm2_w)" />
      </g>

      <g transform="translate(170, 342)">
        <polygon points="0,-55 55,0 0,55 -55,0" fill="url(#dm2_w)" />
      </g>

      <g transform="translate(342, 342)">
        <polygon points="0,-55 55,0 0,55 -55,0" fill="url(#dm1_w)" />
      </g>

      <g transform="translate(256, 256)">
        <polygon points="0,-48 48,0 0,48 -48,0" fill="url(#dm3_w)" />
      </g>

      <line
        x1={225}
        y1={170}
        x2={287}
        y2={170}
        stroke="url(#dm3_w)"
        strokeWidth={8}
        strokeLinecap="round"
      />
      <line
        x1={225}
        y1={342}
        x2={287}
        y2={342}
        stroke="url(#dm4_w)"
        strokeWidth={8}
        strokeLinecap="round"
      />
      <line
        x1={170}
        y1={225}
        x2={170}
        y2={287}
        stroke="url(#dm4_w)"
        strokeWidth={8}
        strokeLinecap="round"
      />
      <line
        x1={342}
        y1={225}
        x2={342}
        y2={287}
        stroke="url(#dm3_w)"
        strokeWidth={8}
        strokeLinecap="round"
      />
    </svg>
  );
}
